import React from 'react';
import { IssuerSnapshot } from '../../types/billing';
type Props = {
  issuer: IssuerSnapshot;
  title: string;
  number: string;
  meta: [string, string][];
  stamp?: string;
};

/** Bmed letterhead + document title block. Uses the issuer snapshot saved with the document. */
export function BillingLetterhead({
  issuer,
  title,
  number,
  meta,
  stamp
}: Props) {
  const {
    business,
    appearance
  } = issuer;
  const align = appearance.logoPlacement === 'center' ? 'flex-col items-center text-center' : appearance.logoPlacement === 'right' ? 'flex-row-reverse text-right' : 'flex-row';
  const logo = `${appearance.logoSizeMm ?? 17}mm`;
  return <header className="break-inside-avoid" data-id="element-2934" data-mp="461y786cn2y8">
      {business.documentHeader && <p className="mb-2 text-center text-[9.5px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-2935" data-mp="85klubpk1s4r">{business.documentHeader}</p>}
      <div className={`flex gap-4 border-b-2 pb-4 ${align}`} style={{
      borderColor: appearance.accentColor
    }} data-id="element-2936" data-mp="3qch2nq4zrek1">
        {business.logoUrl && <img src={business.logoUrl} alt="" crossOrigin="anonymous" className="shrink-0 object-contain" style={{
        width: logo,
        height: logo
      }} data-id="element-2937" data-mp="9dlmj5brp39b" />}
        <div className="min-w-0 flex-1" data-id="element-2938" data-mp="4dh61fav08j3">
          <p className="text-[15px] font-extrabold tracking-wide" style={{
          color: appearance.accentColor
        }} data-id="element-2939" data-mp="4gmx3031tkhg">{business.name}</p>
          {business.tagline && <p className="text-[10px] italic text-slate-600" data-id="element-2940" data-mp="deytxjuideic">{business.tagline}</p>}
          <p className="mt-1 text-[10px] leading-snug text-slate-700" data-id="element-2941" data-mp="3luiiw6o5carl">
            {business.addressLine1}{business.addressLine2 ? `, ${business.addressLine2}` : ''}<br data-id="element-2942" data-mp="3hv9nyyhde6ug" />
            Tel: {business.phone} · {business.email}
            {(business.tpin || business.registrationNumber) && <br data-id="element-2943" data-mp="3vmo6733ge40g" />}
            {business.tpin ? `TPIN: ${business.tpin}` : ''}
            {business.tpin && business.registrationNumber ? ' · ' : ''}
            {business.registrationNumber ? `${business.registrationLabel || 'Reg. No.'}: ${business.registrationNumber}` : ''}
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-start justify-between gap-6" data-id="element-2944" data-mp="122kr8iddt0h5">
        <div data-id="element-2945" data-mp="1206y4f29hyc8">
          <h1 className="text-[20px] font-bold uppercase tracking-wider text-slate-900" data-id="element-2946" data-mp="171e7ujnyt7lj">{title}</h1>
          <p className="text-[12px] font-semibold text-slate-700" data-id="element-2947" data-mp="1bs4ctvshb8fp">{number}</p>
          {stamp && <p className="mt-1 inline-block rounded border-2 border-red-600 px-2 py-0.5 text-[11px] font-bold uppercase tracking-widest text-red-600" data-id="element-2948" data-mp="1bugro02xx2oj">{stamp}</p>}
        </div>
        <dl className="grid grid-cols-[auto_auto] gap-x-4 gap-y-0.5 text-[10.5px]" data-id="element-2949" data-mp="j504bgu6gbz6">
          {meta.map(([k, v]) => <React.Fragment key={k} data-id="element-2950" data-mp="o4mibshtxw91">
              <dt className="text-slate-500" data-id="element-2951" data-mp="t13en9z6ngx7">{k}</dt>
              <dd className="text-right font-semibold text-slate-900" data-id="element-2952" data-mp="t0bls6wyzxam">{v}</dd>
            </React.Fragment>)}
        </dl>
      </div>
    </header>;
}